// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"f02602cc","453":"1373d145"}[chunkId] + ".chunk.js";
};